// extracted by mini-css-extract-plugin
export default {"container":"_885333c2","isViewAllTopAligned":"_3ed594d4","title":"_816f6165","viewAll":"_7c2372a9","viewAllLink":"_d77a2ec9"};